import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import DataTableSecond from "../DataTable/DataTableSecond";
import { useErrorToast } from "../../hooks/useErrorToast";

const RolePermissionsTable = ({ selectedRole, roleId, onBack }) => {
  const [rows, setRows] = useState([]);
  const showError = useErrorToast();

  useEffect(() => {
    const fetchPermissions = async () => {
      const token = localStorage.getItem("tokenInv");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/permission-modules?role_id=${roleId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "ngrok-skip-browser-warning": "true",
            },
          }
        );
        const data = response.data || [];

        let combinedRows = [];

        data.forEach((module) => {
          combinedRows.push({
            id: `module-${module.id}`,
            isModuleHeader: true,
            moduleName: module.name,
          });

          module.permissions.forEach((perm) => {
            combinedRows.push({
              id: `${module.id}-${perm.id}`,
              permission_id: perm.id,
              moduleName: module.name,
              permissionName: perm.name,
              view: perm.show_view ? perm.privileges?.is_view || false : null,
              add: perm.show_add ? perm.privileges?.is_add || false : null,
              edit: perm.show_edit ? perm.privileges?.is_edit || false : null,
              delete: perm.show_delete ? perm.privileges?.is_delete || false : null,
              isModuleHeader: false,
            });
          });
        });

        setRows(combinedRows);
      } catch (error) {
        console.error("Failed to fetch permissions:", error);
      }
    };

    fetchPermissions();
  }, [roleId]);

  // ✅ Update permissions when checkbox is clicked
  const handlePermissionChange = (id, field, value) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  // ✅ Submit to API
  const handleSubmit = async () => {
    const token = localStorage.getItem("tokenInv");

    const payload = {
      role_id: roleId,
      permissions: rows
        .filter((row) => !row.isModuleHeader)
        .map((row) => ({
          permission_id: row.permission_id,
          is_add: row.add || false,
          is_edit: row.edit || false,
          is_view: row.view || false,
          is_delete: row.delete || false,
        })),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/staff-privileges`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message || "Permissions saved successfully!");
    } catch (error) {
      console.error("Error saving permissions:", error);
      showError(error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.msg || "Failed to save permissions.");
      // toast.error(error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.msg || "Failed to save permissions.");
    }
  };

  const columns = [
    {
      field: "permissionName",
      headerName: "Permission",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isModuleHeader) {
          return (
            <strong style={{ fontWeight: "bold", fontSize: 16 }}>
              {params.row.moduleName}
            </strong>
          );
        }
        return params.value;
      },
    },
    ...["view", "add", "edit", "delete"].map((field) => ({
      field,
      headerName: field.toUpperCase(),
      width: 100,
      renderCell: (params) =>
        params.row.isModuleHeader ? (
          ""
        ) : params.row[field] === null ? (
          "-"
        ) : (
          <input
            type="checkbox"
            checked={params.row[field]}
            onChange={(e) =>
              handlePermissionChange(params.row.id, field, e.target.checked)
            }
          />
        ),
    })),
  ];

  return (<>
<Toaster position="top-right" reverseOrder={false}/>
    <Box sx={{ padding: 2 }}>
      <div className="table-header">
        <h2>Permissions for: {selectedRole?.name}</h2>
        <button className="upload-button" onClick={onBack}>
          Back to Roles
        </button>
      </div>

      <DataTableSecond
        rows={rows}
        columns={columns}
        autoHeight
        hideFooter
        disableSelectionOnClick
        getRowClassName={(params) =>
          params.row.isModuleHeader ? "module-header-row" : ""
        }
      />

      {/* ✅ Save Button */}
      <Box sx={{ textAlign: "right", marginTop: 2 }}>
        <Button variant="contained" color="primary" onClick={handleSubmit} sx={{backgroundColor: "rgb(124, 46, 160)"}}>
          Save Permissions
        </Button>
      </Box>
    </Box>
    </>
  );
};

export default RolePermissionsTable;
